var map = {
	"./Amazing yoga performance by the Boarding House Girls of HGS Bhimtal and Instructor..mp4": 84297,
	"./Fabulous performance on Shiv Tandav by Miss Mitali Pandey class X student of HGS, Bhimtal.mp4": 21008,
	"./Flag Song.mp4": 39610,
	"./Virtual Tour to Art and Gandhi Gallery HGS Bhimtal.mp4": 59539,
	"./b.mp4": 68651,
	"./m.mp4": 41168,
	"./watermelon day celebrartion final video.mp4": 62794
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 88285;